<template>
  <div class="hero__container">
    <prismic-image
      :field="slice.primary.hero_image"
      v-if="slice.primary.hero_image"
    />
  </div>
</template>

<script>
export default {
  props: {
    slice: Object,
  },
};
</script>

<style lang="scss" scoped>
.hero__container{
    width: 100%;
}
</style>
